import { dispatch } from '../index'

import {
    ADD_CONTENT_TO_PLAYLIST,
    ADD_TRANSLATED_PLAYLIST,
    ADD_TRANSLATED_QUIZ,
    ADD_TRANSLATED_SECTION,
    ADD_TRANSLATED_VIDEO,
    CLEAR_HISTORY,
    HANDLE_PLAYLIST,
    NEXT_PLAYLIST_CONTENT,
    POP_FROM_HISTORY,
    PREVIOUS_PLAYLIST_CONTENT,
    PUSH_TO_HISTORY,
    RESET_TRAINING_PROGRAM,
    SET_ACTIVE_CONTENT,
    SET_ACTIVE_TRANSLATION,
    SET_IS_TRANSLATING,
    SET_NEXT_BUTTON_DISABLED,
    SET_SHOW_COMPLETION,
    SET_UPDATING_TRAINING_RESULT,
    SET_VIDEO_AUTOPLAY,
    SET_VIDEO_CC,
} from '../actionTypes'

export const addContentToPlaylist = (input) =>
    dispatch({
        ...input,
        type: ADD_CONTENT_TO_PLAYLIST,
    })

export const addTranslatedPlaylist = (translation) =>
    dispatch({
        translation,
        type: ADD_TRANSLATED_PLAYLIST,
    })

export const addTranslatedQuiz = (contentIndex, sectionIndex, translation) =>
    dispatch({
        contentIndex,
        sectionIndex,
        translation,
        type: ADD_TRANSLATED_QUIZ,
    })

export const addTranslatedSection = (sectionIndex, translation) =>
    dispatch({
        sectionIndex,
        translation,
        type: ADD_TRANSLATED_SECTION,
    })

export const addTranslatedVideo = (contentIndex, sectionIndex, translation) =>
    dispatch({
        contentIndex,
        sectionIndex,
        translation,
        type: ADD_TRANSLATED_VIDEO,
    })

export const clearHistory = () =>
    dispatch({
        type: CLEAR_HISTORY,
    })

export const handlePlaylist = (playlist) =>
    dispatch({
        playlist,
        type: HANDLE_PLAYLIST,
    })

export const popFromHistory = () =>
    dispatch({
        type: POP_FROM_HISTORY,
    })

export const nextPlaylistContent = () =>
    dispatch({
        type: NEXT_PLAYLIST_CONTENT,
    })

export const previousPlaylistContent = () =>
    dispatch({
        type: PREVIOUS_PLAYLIST_CONTENT,
    })

export const pushToHistory = (key) =>
    dispatch({
        key,
        type: PUSH_TO_HISTORY,
    })

export const resetTrainingProgram = () =>
    dispatch({
        type: RESET_TRAINING_PROGRAM,
    })

export const setActiveContent = (sectionIndex, contentIndex) =>
    dispatch({
        sectionIndex,
        contentIndex,
        type: SET_ACTIVE_CONTENT,
    })

export const setActiveTranslation = (translation) =>
    dispatch({
        translation,
        type: SET_ACTIVE_TRANSLATION,
    })

export const setIsTranslating = () =>
    dispatch({
        type: SET_IS_TRANSLATING,
    })

export const setNextButtonDisabled = (bool) =>
    dispatch({
        bool,
        type: SET_NEXT_BUTTON_DISABLED,
    })

export const setShowCompletion = (bool) =>
    dispatch({
        bool,
        type: SET_SHOW_COMPLETION,
    })

export const setUpdatingTrainingResult = (bool) =>
    dispatch({
        bool,
        type: SET_UPDATING_TRAINING_RESULT,
    })

export const setVideoAutoPlay = (bool) =>
    dispatch({
        bool,
        type: SET_VIDEO_AUTOPLAY,
    })

export const setVideoCC = (bool) =>
    dispatch({
        bool,
        type: SET_VIDEO_CC,
    })
